// extracted by mini-css-extract-plugin
export default {"wrapper":"ProviderAccordion_wrapper__ud-Ih","disabled":"ProviderAccordion_disabled__+bA28","header":"ProviderAccordion_header__1krcC","details":"ProviderAccordion_details__C6U1r"};